import type { ErrorInfo, ReactNode } from 'react';
import { Component } from 'react';
import { useLocation } from 'react-router-dom';

import ErrorPage from '@/pages/ErrorPage';

type Props = {
  readonly children: ReactNode;
};

type State = {
  readonly error?: Error;
};

class ErrorBoundaryImpl extends Component<Props, State> {
  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  public state: State = {};

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[Logto Experience] page render failed', error, errorInfo);
    console.error('[Logto Experience] render error stack', error.stack);
    console.error('[Logto Experience] render component stack', errorInfo.componentStack);
    console.error('[Logto Experience] render location', window.location.href);
  }

  render() {
    if (this.state.error) {
      return <ErrorPage title="error.unknown" />;
    }

    return this.props.children;
  }
}

const ErrorBoundary = ({ children }: Props) => {
  const location = useLocation();

  return (
    <ErrorBoundaryImpl key={`${location.pathname}${location.search}`}>{children}</ErrorBoundaryImpl>
  );
};

export default ErrorBoundary;
